export enum RoleName {
    CENTRAL_ADMIN = "CENTRAL_ADMIN",
    STORE_ADMIN = "STORE_ADMIN",
    MANAGER = "MANAGER",
    USER = "USER",
    DRIVE_USER = "DRIVE_USER"
}